/**
 * Accès au tableau de bord.
 *
 * Le tableau de bord proposait quatre dispositions au choix, chacune ouverte ou fermée par
 * rôle. Il n'y en a plus qu'une, et la question se réduit à celle-ci : ce rôle donne-t-il
 * accès au tableau de bord, ou non.
 *
 * Les anciens réglages sont convertis à la lecture plutôt que dans la base : les rôles
 * déjà enregistrés continuent de fonctionner, et une conversion ratée ne peut rien perdre.
 */

/** Un accès est ouvert tant qu'il n'a pas été explicitement fermé. */
function allowed(value) {
  return value !== false
}

/**
 * Ce rôle donne-t-il accès au tableau de bord ?
 *
 * Un réglage d'avant la refonte portait une clé par disposition : le rôle avait accès au
 * tableau de bord dès lors qu'au moins l'une d'elles lui était ouverte.
 */
export function canAccessDashboard(rights) {
  const source = rights || {}
  if (source.enabled !== undefined) return allowed(source.enabled)

  const legacy = ['detailed', 'simple', 'attractivity', 'finance']
    .filter(key => source[key] !== undefined)

  if (!legacy.length) return true
  return legacy.some(key => allowed(source[key]))
}

/** Réglage tel qu'il est enregistré désormais. */
export function dashboardRights(enabled) {
  return { enabled: Boolean(enabled) }
}

/** Réunion des accès de plusieurs rôles : il suffit qu'un seul l'ouvre. */
export function mergeDashboardAccess(roleRights) {
  const list = roleRights || []
  if (!list.length) return false
  return list.some(rights => canAccessDashboard(rights))
}

export default { canAccessDashboard, dashboardRights, mergeDashboardAccess }
